import React, { useState, useEffect } from 'react';
import { getUserById } from '../../utils/api'; // Adjust the path to where getUserById is located
import axios from 'axios';
import { Stack, Box } from '@mui/system';
import emailjs from '@emailjs/browser';
import Loader from '../Loader.js';
const TrainerHunt = ({ userId }) => {
    const [user, setUser] = useState(null);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    // Fetch user data when the component mounts
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getUserById(userId);
                setUser(userData);
            } catch (error) {
                console.error('Error fetching user data:', error);
                setMessage('Failed to load user data.');
            }
        };
        fetchUser();
    }, [userId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const templateParams = {
                name: user.username,
                email: user.email,
                phone: user.phone || 'Not provided',
                message: comment,
                time: new Date().toLocaleString(),
            };
            //await emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', templateParams, 'YOUR_USER_ID');
            await emailjs.send('service_46bv0oq', 'template_qedmi1r', templateParams, 'yH0mz21D4OHFGHtEf');
            setMessage('!הבקשה נשלחה');
            setComment('');
        } catch (error) {
            console.error('Error sending request:', error);
            setMessage('Failed to send request. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box
            sx={{
                maxWidth: '400px',
                margin: '0 auto',
                padding: '20px',
                direction: 'rtl',
                display: 'flex',
                justifyContent: 'flex-end',
            }}
        >
            <Stack spacing={2} direction="column" alignItems="flex-end">
                {/* Title aligned to the right */}
                <Box sx={{ width: '100%', textAlign: 'right' }}>
                    <h2
                        style={{
                            color: '#8B4513',
                            fontFamily: 'GveretLevin',
                            fontSize: '2rem',
                            margin: 0,
                            direction: 'rtl'
                        }}
                    >
                        התאמת מאמן עבורך
                    </h2>
                </Box>



                {user ? (
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2} direction="column">
                            {/* Name and Email side by side */}
                            <Stack direction="row" spacing={2}>
                                <Box sx={{ flex: 1 }}>
                                    <input
                                        type="text"
                                        value={user.username || 'N/A'}
                                        readOnly
                                        placeholder="שם"
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #8B4513',
                                            borderRadius: '20px',
                                            fontSize: '1rem',
                                            color: '#8B4513',
                                            backgroundColor: '#f9f9f9',
                                            direction: 'rtl',
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <input
                                        type="email"
                                        value={user.email || 'N/A'}
                                        readOnly
                                        placeholder="מייל *"
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #8B4513',
                                            borderRadius: '20px',
                                            fontSize: '1rem',
                                            color: '#8B4513',
                                            backgroundColor: '#f9f9f9',
                                            direction: 'rtl',
                                        }}
                                    />
                                </Box>
                            </Stack>

                            {/* Phone Number */}
                            <Box>
                                <input
                                    type="text"
                                    value={user.phone || 'לא סופק'}
                                    readOnly
                                    placeholder="מספר טלפון"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid #8B4513',
                                        borderRadius: '20px',
                                        fontSize: '1rem',
                                        color: '#8B4513',
                                        backgroundColor: '#f9f9f9',
                                        direction: 'rtl',
                                    }}
                                />
                            </Box>

                            {/* Comment */}
                            <Box>
                                <textarea
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    placeholder="ניסוח בקשה"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid #8B4513',
                                        borderRadius: '20px',
                                        fontSize: '1rem',
                                        color: '#8B4513',
                                        minHeight: '100px',
                                        resize: 'vertical',
                                        direction: 'rtl',
                                    }}
                                />
                            </Box>

                            {/* Submit Button aligned to the left */}
                            <Box sx={{ width: '100%', textAlign: 'left' }}>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        backgroundColor: '#8B4513',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        fontSize: '1rem',
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                    }}
                                >
                                    {loading ? '...שליחה' : 'שלח'}
                                </button>
                            </Box>
                        </Stack>
                    </form>
                ) : (
                    <Box>
                        <Loader />
                    </Box>
                )}
                {message && (
                    <Box>
                        <p
                            style={{
                                color: message.includes('נשלחה') ? 'green' : 'red',
                                margin: 0,
                            }}
                        >
                            {message}
                        </p>
                    </Box>
                )}
            </Stack>
        </Box>
    );
};

export default TrainerHunt;